import { Block } from '@components/core-ui/Block';
import { Divider } from '@components/core-ui/Divider';
import { ErrorMessage } from '@components/core-ui/ErrorMessage';
import { GenericPageError } from '@components/core-ui/GenericPageError';
import { Popover } from '@components/core-ui/Popover';
import { Tooltip } from '@components/core-ui/Tooltip';
import { JobStatusText } from '@components/JobStatusText';
import { VsLogo } from '@components/Logo';
import { useRef, useState } from 'react';

export const JobStatusTextDemo = () => (
  <div className="flex flex-wrap gap-4">
    <JobStatusText status="JOB_STATUS_COMPLETE" />
    <JobStatusText status="JOB_STATUS_PROCESSING" />
    <JobStatusText status="JOB_STATUS_ERROR" />
    <JobStatusText status="JOB_STATUS_DRAFT" />
    <JobStatusText status="unknown" removed />
  </div>
);

export const LogoDemo = () => (
  <div className="flex flex-wrap gap-8">
    <VsLogo />
    <VsLogo hideText />
  </div>
);

export const DividerDemo = () => (
  <div className="flex flex-col gap-4">
    <Divider />
    <div className="flex h-12 items-center gap-4">
      <span className="text-sm">Left</span>
      <Divider vertical />
      <span className="text-sm">Right</span>
    </div>
  </div>
);

export const ErrorMessageDemo = () => <ErrorMessage error="Sample validation error" />;

export const GenericPageErrorDemo = () => <GenericPageError message="Something went wrong loading this section." />;

export const BlockDemo = () => (
  <Block title="Block title" description={<p>Block description text.</p>}>
    <div className="text-sm text-[var(--color-text)]">Right side content</div>
  </Block>
);

export const PopoverDemo = () => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  return (
    <div ref={anchorRef} className="relative inline-block">
      <button
        type="button"
        className="rounded border border-[var(--color-border)] px-3 py-1.5 text-sm"
        onClick={() => setOpen(true)}
      >
        Open popover
      </button>
      <Popover open={open} onClose={() => setOpen(false)} anchorEl={anchorRef.current}>
        <div className="p-3 text-sm">Popover content</div>
      </Popover>
    </div>
  );
};

export const TooltipDemo = () => (
  <div className="flex flex-wrap gap-8 py-6">
    <Tooltip content="Assignee email on hover" placement="bottom">
      <button type="button" className="rounded border border-[var(--color-border)] px-3 py-1.5 text-sm">
        Bottom
      </button>
    </Tooltip>
    <Tooltip content="Hint on the right" placement="right">
      <button type="button" className="rounded border border-[var(--color-border)] px-3 py-1.5 text-sm">
        Right
      </button>
    </Tooltip>
    <Tooltip content="Time since user checked out the job and uploaded their latest version" placement="bottom">
      <button type="button" className="rounded border border-[var(--color-border)] px-3 py-1.5 text-sm">
        Long text
      </button>
    </Tooltip>
  </div>
);
